@if (fetchingAuths()) {
<rs-loader></rs-loader>
}
<!-- {{userInfo.adminRole}} -->
<div class="auth-at-group-level">
    @if (errors()) {
    <p class="error">{{errors()}}</p>
    }
    @if (!errors() && userAndAdminAuths().userRelatedAuthorizations && userAndAdminAuths().userRelatedAuthorizations.length && selectedUserId()) {
        <table>
            <thead>
                <th>Auth given</th>
                <th>Subgroup ID</th>
                <th>Subgroup Name</th>
                @if (userAndAdminAuths().adminRelatedAuthorizations.eligibilityAccessLevel) { <th>Eligibility Access</th> }
                @if (userAndAdminAuths().adminRelatedAuthorizations.clientKnowledgeIndicator) { <th>Client Knowledge</th> }
                @if (userAndAdminAuths().adminRelatedAuthorizations.customClientReportAccessIndicator) { <th>Custom Client Reports</th> }
                @if (userAndAdminAuths().adminRelatedAuthorizations.billingReportAccessIndicator) { <th>Billing Report</th> }
                @if (userAndAdminAuths().adminRelatedAuthorizations.claimDetailReportAccessIndicator) { <th>Claim Detail Report</th> }
                @if (userAndAdminAuths().adminRelatedAuthorizations.satAccessLevel) { <th>Sat Access Level</th> }
            </thead>
            <tbody>
                @for (user of userAndAdminAuths().userRelatedAuthorizations; track user.subGroupSpecifiedIdentifier) {
                    <tr>
                        <td>
                            <rs-checkbox [id]="user.subGroupSpecifiedIdentifier+'userPrivilegeSelected'" [checked]="user.userPrivilegeSelected" disabled></rs-checkbox>
                        </td>
                        <td>{{user.subGroupSpecifiedIdentifier}}</td>
                        <td>{{user.subGroupName}}</td>
                        @if (userAndAdminAuths().adminRelatedAuthorizations.eligibilityAccessLevel) {
                        <td>
                            @if (adminSubGroupAuths()[user.subGroupSpecifiedIdentifier]?.eligibilityAccessLevel) {
                                {{user.eligibilityAccessLevel || 'None'}}
                            }
                        </td>
                        }
                        @if (userAndAdminAuths().adminRelatedAuthorizations.clientKnowledgeIndicator) {
                        <td>
                            @if (adminSubGroupAuths()[user.subGroupSpecifiedIdentifier]?.clientKnowledgeIndicator) {
                                <rs-checkbox [id]="user.subGroupSpecifiedIdentifier+'clientKnowledgeIndicator'" [checked]="user.clientKnowledgeIndicator" disabled></rs-checkbox>
                            }
                        </td>
                        }
                        @if (userAndAdminAuths().adminRelatedAuthorizations.customClientReportAccessIndicator) {
                        <td>
                          @if (adminSubGroupAuths()[user.subGroupSpecifiedIdentifier]?.customClientReportAccessIndicator) {
                            <rs-checkbox [id]="user.subGroupSpecifiedIdentifier+'customClientReportAccessIndicator'" [checked]="user.customClientReportAccessIndicator" disabled></rs-checkbox>
                          }
                        </td>
                        }
                        @if (userAndAdminAuths().adminRelatedAuthorizations.billingReportAccessIndicator) {
                        <td>
                            @if (adminSubGroupAuths()[user.subGroupSpecifiedIdentifier]?.billingReportAccessIndicator) {
                                <rs-checkbox [id]="user.subGroupSpecifiedIdentifier+'billingReportAccessIndicator'" [checked]="user.billingReportAccessIndicator" disabled></rs-checkbox>
                            }
                        </td>
                        }
                        @if (userAndAdminAuths().adminRelatedAuthorizations.claimDetailReportAccessIndicator) {
                        <td>
                            @if (adminSubGroupAuths()[user.subGroupSpecifiedIdentifier]?.claimDetailReportAccessIndicator) {
                                <rs-checkbox [id]="user.subGroupSpecifiedIdentifier+'claimDetailReportAccessIndicator'" [checked]="user.claimDetailReportAccessIndicator" disabled></rs-checkbox>
                            }
                        </td>
                        }
                        @if (userAndAdminAuths().adminRelatedAuthorizations.satAccessLevel) {
                        <td>
                            @if (adminSubGroupAuths()[user.subGroupSpecifiedIdentifier]?.satAccessLevel) {
                                {{user.satAccessLevel || 'None'}}
                            }
                        </td>
                        }
                    </tr>
                }
            </tbody>
        </table>
    }
    @if (!errors() && userAndAdminAuths().relatedAuthorizations && userAndAdminAuths().relatedAuthorizations.length && !selectedUserId()) {
        <table>
            <thead>
                <th>Subgroup ID</th>
                <th>Subgroup Name</th>
                <th>Eligibility Access</th>
            </thead>
            <tbody>
                @for (user of userAndAdminAuths().relatedAuthorizations; track user?.subGroupSpecifiedIdentifier || $index) {
                    @if (user && user.subGroupSpecifiedIdentifier) {
                    <tr>
                        <td>{{user.subGroupSpecifiedIdentifier}}</td>
                        <td>{{user.subGroupName}}</td>
                        <td>
                            {{user.eligibilityAccessLevel || 'None'}}
                        </td>
                    </tr>
                    }
                }
            </tbody>
        </table>
    }
    @if (!fetchingAuths() && !errors() && ((userAndAdminAuths().userRelatedAuthorizations && !userAndAdminAuths().userRelatedAuthorizations.length)|| (userAndAdminAuths().relatedAuthorizations && !userAndAdminAuths().relatedAuthorizations.length))) {
        <p class="error">No authorizations were assigned {{(userAndAdminAuths().userRelatedAuthorizations && !userAndAdminAuths().userRelatedAuthorizations.length) ? 'for this user' : ''}} </p>
    }
    <div class="pagination-container">
        <rs-paginator [length]="totalAuths()"
                        (page)="getMoreAuths($event)" [showFirstLastButtons]="1"
                        [pageSize]="defaultPageSize" ></rs-paginator>
    </div>
</div>
